var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWarning(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3209 3.95765L3.60219 18.564C3.324 19.0904 3.70566 19.7238 4.30106 19.7238H19.7064C20.3013 19.7238 20.683 19.0916 20.4059 18.5652L12.7193 3.95885C12.4233 3.39628 11.618 3.39559 11.3209 3.95765ZM9.99472 3.25682L2.27598 17.8632C1.46989 19.3885 2.57579 21.2238 4.30106 21.2238H19.7064C21.43 21.2238 22.536 19.3919 21.7334 17.8666L14.0467 3.2603C13.1889 1.63017 10.8554 1.62817 9.99472 3.25682Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0358 8.49942C11.0163 7.95335 11.4536 7.50005 12.0001 7.50005C12.5465 7.50005 12.9839 7.95335 12.9644 8.49942L12.7768 13.7505C12.7619 14.1687 12.4185 14.5001 12.0001 14.5001C11.5816 14.5001 11.2382 14.1687 11.2233 13.7505L11.0358 8.49942Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0001 16.5001C13.0001 17.0523 12.5523 17.5001 12.0001 17.5001C11.4478 17.5001 11.0001 17.0523 11.0001 16.5001C11.0001 15.9478 11.4478 15.5001 12.0001 15.5001C12.5523 15.5001 13.0001 15.9478 13.0001 16.5001Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.e2752ea2.svg";
export { ForwardRef as ReactComponent };